
import { Button, Checkbox, Col, Popover, Row,TableColumnProps } from 'antd'
import React from 'react'
import ReactDOM from 'react-dom'
import Icon, {   LockFilled,ArrowUpOutlined,ArrowDownOutlined, LockOutlined } from '@ant-design/icons'
import styled from 'styled-components'

type CustomBoolean  = 'T' | 'F'

const renderEl = document.querySelector('body')

const TableFieldSetView = styled.div`

  &.table-field-set{
    overflow: hidden;
    position: fixed;
    z-index: 12;
    top: 0px;
    left: 0px;
    bottom: 0px;
    width: 0;
    white-space: nowrap;
    background-color: #fff;
    box-shadow: 4px 4px 4px 4px rgba(0,0,0,0.10);
    transition: width .25s;
    display: flex;
    flex-direction: column;
    .hidden{
      visibility: hidden;
    }
  }
  &.table-field-set > div:nth-child(n){
    padding: 16px;
  }
  &.table-field-set > div:nth-child(1){
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    border-bottom: 1px solid #f0f0f0;
  }
  .table-field-wrap, .table-field-footer{
    width: 100%;
  }
  &.table-field-set > div.table-field-wrap{
    padding: 0 16px;
    top: 65px;
    bottom: 65px;
  }
  .table-field-wrap {
    flex: 1;
    overflow-y: scroll;
    .column-item{
      line-height: 46px;
    }
  }
  .table-arrow-wrap{
    display: none;
    flex: 1;
  }
  .table-arrow-wrap > .anticon{
    font-size: 16px;
    cursor: pointer;
  }
  .table-field-wrap .column-item:hover .table-arrow-wrap{
    display: inline-block;
  }
  .table-set-arrow{
    margin: 0 24px 0 30px;
  }
  .table-set-lock{
    margin-left: 40px;
    font-size: 16px;
    cursor: pointer;
  }
  .table-set-arrow + .anticon{
    font-size: 16px;
    cursor: pointer;
  }
  .table-field-footer{
    bottom: 0;
    border-top: 1px solid #f0f0f0;
  }
`



export interface TableFieldSetColumn<T extends Record<string,any> = any>  extends Omit<TableColumnProps<T>,'dataIndex'> {
  dataIndex:  ((keyof  T) extends string ?  keyof T  : string)  | 'sequence'
  // title: string | React.ReactNode
  switchShow?: CustomBoolean   //锁定后，CheckBox不可选，显示锁定标，隐藏上下排序箭头；
  switchFixed?: CustomBoolean   //隐藏上箭头（不可上移），上一项switchFixed=F，显示上箭头（可上移）
  show?: CustomBoolean  //是否展示
  // width: number
  help_text?:string
  isSerial?: boolean //服务端配置的序号，只用于导出
}

interface TableFieldSetProps {
  columns: TableFieldSetColumn[]
  visible: boolean
  onClose?(): void
  onSure(columns:TableFieldSetColumn[]):void
  onRest(columns:TableFieldSetColumn[]):void
}
/* 
  列配置项
  switchShow：是否锁定，F/T；
  switchFixed：是否可排序（显示箭头）；
  
  1、switchShow=F > 锁定后，CheckBox不可选，显示锁定标，隐藏上下排序箭头；
  2、switchShow=T > 不锁定，CheckBox可选，不显示锁定标，根据兄弟项switchFixed值展示上下排序箭头；
      1）上一项switchFixed=T，隐藏上箭头（不可上移），上一项switchFixed=F，显示上箭头（可上移）
      2）下一项switchFixed=T，隐藏下箭头（不可下移），下一项switchFixed=F，显示下箭头（可下移）
*/
export const TableFieldSet = (props: TableFieldSetProps) => {
  const [columns,setColumns] = React.useState<TableFieldSetColumn[]>(props.columns)
  React.useEffect(()=>{
    setColumns(props.columns)
  },[ props.columns ])
  const { visible } = props

  const onClose = ()=>{
    props.onClose && props.onClose()
  }
  const onSure = ()=>{
    props.onSure(columns)
  }
  const onRest = ()=>{
    props.onRest(columns)
  }
  const onMove = (type: 'up' | 'down', index: number) => {
    if (type === 'up') {
      [columns[index - 1], columns[index]] = [columns[index], columns[index - 1]]
    }
    else if (type === 'down') {
      [columns[index], columns[index + 1]] = [columns[index + 1], columns[index]]
    }
    setColumns([...columns])
  }
  const getTitle = (item:TableFieldSetColumn)=>{
    let title =  item.title as React.ReactNode
    if(item.help_text){
        return <React.Fragment>
            {title}
            <Popover content={<div dangerouslySetInnerHTML={{ __html: item.help_text }}></div>} trigger="hover">
                <Icon type="question-circle" style={{marginLeft:'2px'}} />
            </Popover>
        </React.Fragment>
    }
    return title
  }
  const onChange = (checked:boolean,index:number)=>{
    setColumns(columns=>{
      columns[index].show = checked ? 'T' : 'F'
      return [...columns]
    })
    // this.setState({columns})
  }
  let _style = {
    width: visible ? '300px' : 0
}
  if(!visible || !renderEl){
    return null
  }
  return (
    ReactDOM.createPortal(
      <TableFieldSetView className="table-field-set" style={_style} >
        <div>
          <Row gutter={28}>
            <Col span={10} className="text-right">字段</Col>
            <Col span={14}>
              <span>显示</span>
              {/* <span style={{ marginLeft: '26px' }}>锁定</span> */}
              <span className="table-set-arrow">移动</span>
            </Col>
          </Row>
        </div>
        <div className="table-field-wrap">
          <div>
            <div>
              {columns.map((item, index, columns) => {
                // if (index < 1) return <React.Fragment key={item.dataIndex} />;
                const arrowDownHidden = (columns[(index + 1)] && columns[(index + 1)].switchFixed === 'T') || index == columns.length - 1;
                const arrowUpHidden = index == 0 || columns[(index - 1)] && columns[(index - 1)].switchFixed === 'T'
                return (
                  <div key={item.dataIndex} className='column-item' style={{height:'45px'}}>
                    <Row gutter={28}>
                      <Col span={10} className="text-right">
                        {/* {index === 1 ? <span style={{verticalAlign: 'middle'}}>{item.titleText || item.title}</span> : <span>{item.titleText || item.title}</span>} */}
                        {index === 1 ? <span style={{ verticalAlign: 'middle' }}>{getTitle(item)}</span> : <span>{getTitle(item)}</span>}
                      </Col>

                      <Col span={14}>
                        <Checkbox disabled={item.switchShow === 'F'} value={index} checked={item.show === 'T'} onChange={(e)=>onChange(e.target.checked,index)} />
                        {/* <LockOutlined className={`table-set-lock ${item.switchShow === 'F' ? '' : 'hidden'}`} type="lock" /> */}
                        <span className={`table-arrow-wrap ${item.switchShow === 'F' ? 'hidden' : ''}`}>
                          <ArrowUpOutlined
                            className={`table-set-arrow ${arrowUpHidden ? 'hidden' : ''}`}
                            onClick={()=>onMove('up', index)}
                            type="arrow-up"
                          />
                          <ArrowDownOutlined
                            className={`${arrowDownHidden ? 'hidden' : ''}`}
                            onClick={()=>onMove('down', index)}
                            type="arrow-down"
                          />
                        </span>
                      </Col>
                    </Row>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        <div className="table-field-footer">
          <Row>
            <Col span={10}><a className="list-link" onClick={  onRest } style={{ lineHeight: '32px' }}>恢复默认</a></Col>
            <Col span={14} className="text-right">
              <Button onClick={onClose}>取消</Button>
              <Button type="primary" style={{ marginLeft: '10px' }} onClick={ onSure}>确定</Button>
            </Col>
          </Row>
        </div>
      </TableFieldSetView>,
      renderEl
    )
  )
}